import { render, staticRenderFns } from "./TheGlobalProvider.vue?vue&type=template&id=54465540&"
import script from "./TheGlobalProvider.vue?vue&type=script&lang=ts&"
export * from "./TheGlobalProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports